import React from "react";
import {
  FaAssistiveListeningSystems,
  FaBars,
  FaMoneyBill,
  FaRecordVinyl,
  FaSitemap,
  FaSignOutAlt,
  FaUser,
} from "react-icons/fa";
import { IoSettingsSharp } from "react-icons/io5";
import { FaBuildingColumns, FaCircleDot } from "react-icons/fa6";
import { MdSubscriptions, MdPrivacyTip } from "react-icons/md";
import { TbCircleDotFilled } from "react-icons/tb";

interface BurgerMenuProps {
  showMenu: boolean;
  toggleMenu: () => void;
  handleUserProfileClick: () => void;
  handleSettingsClick: () => void;
  handleSubscriptionPlansClick: () => void;
  handleTermsAndConditionsClick: () => void;
  handlePrivacyPolicyClick: () => void;
  //handleFocusMapSiteClick: () => void;
  handleSignOut: () => void;
  isAuthenticated: boolean; // Add this line
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({
  showMenu,
  toggleMenu,
  handleUserProfileClick,
  handleSettingsClick,
  handleSubscriptionPlansClick,
  handleTermsAndConditionsClick,
  handlePrivacyPolicyClick,
  //handleFocusMapSiteClick,
  handleSignOut,
  isAuthenticated,
}) => {
  return (
    <>
      <FaBars className="homepage-burger-menu" onClick={toggleMenu} />
      {showMenu && (
        <div className="homepage-menu-dropdown">
          {isAuthenticated && (
            <div className="burger-menu-item-row">
              <FaUser
                color="#546484"
                size={20}
                className="homepage-burger-menu-icon"
                onClick={toggleMenu}
              />
              <button
                className="homepage-burger-menu-item"
                onClick={handleUserProfileClick}
              >
                User Profile
              </button>
            </div>
          )}

          {/* {isAuthenticated && */}
          {/* <div className="burger-menu-item-row">
            <TbCircleDotFilled color="#546484" size={20} className="homepage-burger-menu-icon" onClick={toggleMenu} />
            <button className="homepage-burger-menu-item" onClick={handleFocusMapSiteClick}>FocusMap</button>
          </div> */}

          <div className="burger-menu-item-row">
            <FaBuildingColumns
              color="#546484"
              size={20}
              className="homepage-burger-menu-icon"
              onClick={toggleMenu}
            />
            <button
              className="homepage-burger-menu-item"
              onClick={handleTermsAndConditionsClick}
            >
              Terms & Conditions
            </button>
          </div>

          <div className="burger-menu-item-row">
            <MdPrivacyTip
              color="#546484"
              size={20}
              className="homepage-burger-menu-icon"
              onClick={toggleMenu}
            />
            <button
              className="homepage-burger-menu-item"
              onClick={handlePrivacyPolicyClick}
            >
              Privacy Policy
            </button>
          </div>

          {isAuthenticated && (
            <div className="burger-menu-item-row">
              <FaSignOutAlt
                color="#546484"
                size={20}
                className="homepage-burger-menu-icon"
                onClick={toggleMenu}
              />
              <button
                className="homepage-burger-menu-item"
                onClick={handleSignOut}
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default BurgerMenu;
